export const isArray = function (a) {
  return Array.isArray(a)
}

export const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

export const snakeToCamel = (str) => {
  return str.replace(/(_\w)/g, (k) => k[1].toUpperCase())
}

export const camelToSnake = (str) => {
  return str
    .split('')
    .map((character) => {
      if (character === character.toUpperCase()) {
        return '_' + character.toLowerCase()
      }
      return character
    })
    .join('')
}

export const coaFormat = (str) => {
  if (str) {
    return str.toString().replace(/^(\d{3})(\d{2})(\d{2})(\d{2}).*/, '$1.$2.$3.$4')
  }
}

export const npwpFormat = (str) => {
  if (str) {
    return str
      .toString()
      .replace(
        /(\d{2})(\d{3})(\d{3})(\d)(\d{3})(\d{3})/,
        '$1.$2.$3.$4-$5.$6'
      )
  }
}

export const textCapitalize = (str) => {
  return str.replace(/\b\w/g, l => l.toUpperCase())
}

export const capitalizeFirstLetter = (string) => {
  const arr = string.split(' ')

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].toLowerCase()
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
  }

  return arr.join(' ')
}

export const keysToCamel = function (data) {
  const toCamel = (s) => {
    return s.replace(/([-_][a-z])/ig, ($1) => {
      return $1.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    })
  }

  if (isObject(data)) {
    const n = {}

    Object.keys(data)
      .forEach((k) => {
        n[toCamel(k)] = keysToCamel(data[k])
      })

    return n
  } else if (isArray(data)) {
    return data.map((i) => {
      return keysToCamel(i)
    })
  }

  return data
}

export const removeNull = function (data) {
  if (isObject(data)) {
    return Object.fromEntries(
      Object.entries(data)
        .filter(([_, value]) => value !== null)
        .map(([key, value]) => [
          key,
          value === Object(value) ? removeNull(value) : value
        ])
    )
  } else if (isArray(data)) {
    return data.filter(item => {
      let filtered
      if (item !== null) {
        filtered = Object.entries(item).filter(([key, val]) => {
          if (isArray(item[key])) removeNull(item[key])
          if (val === null || val === []) {
            delete item[key]
          }
          return item
        })
      }
      return filtered
    })
  }
}

export const slugify = function (text, separator = '-') {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, separator)
}

export const truncateText = (text, maxLength, ellipsis = '...') => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength - ellipsis.length)}${ellipsis}`
  }

  return text
}

export const getInitials = (str) => {
  const names = str.split(' ')
  let initials = names[0].substring(0, 1).toUpperCase()

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  }

  return initials
}

export const removeHtmlTags = (text) => {
  const el = document.createElement('div')
  el.innerHTML = text
  return el.textContent || el.innerText || ''
}

export function truncateFileName (fileName, maxLength) {
  if (fileName?.length > maxLength) {
    const extension = fileName?.substring(fileName?.lastIndexOf('.'))
    const truncatedName = fileName?.substring(0, maxLength - extension?.length)
    return `${truncatedName}...${extension}`
  }

  return fileName
}

export function camelCaseToUpperCaseWithSpace (str) {
  const words = str.replace(/([A-Z])/g, ' $1').trim()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export const replaceAllWithCondition = ({ is = true, source, replacer, pattern }) => {
  if (is) {
    return source?.replaceAll(pattern, (match) => {
      const isMatchCapitalized = match[0] === match[0].toUpperCase()

      if (isMatchCapitalized) {
        return replacer[0].toUpperCase() + replacer.slice(1)
      }

      return replacer
    })
  }

  return source
}

export function replaceSendToPickup (text, condition) {
  return replaceAllWithCondition({
    is: condition,
    pattern: /pengiriman/gi,
    source: text,
    replacer: 'pengambilan'
  })
}
